import React from "react";
import ReactDatePicker, {registerLocale, ReactDatePickerProps } from "react-datepicker";
import "./styles.css";
import { LANGUAGE } from "@stores/SettingsStore";
import { useStores } from "@stores";
import { useObserver } from "mobx-react-lite";
import {ru, es, enGB, uk, de, fr, pl, ro, hu} from 'date-fns/locale';

registerLocale(LANGUAGE.RU, ru);
registerLocale(LANGUAGE.ES, es);
registerLocale(LANGUAGE.EN, enGB);
registerLocale(LANGUAGE.UK, uk);
registerLocale(LANGUAGE.DE, de);
registerLocale(LANGUAGE.FR, fr);
registerLocale(LANGUAGE.PL, pl);
registerLocale(LANGUAGE.RO, ro);
registerLocale(LANGUAGE.HU, hu);


interface IProps extends ReactDatePickerProps {
  datesWithData?: Date[];
}

const DatePicker: React.FC<IProps> = ({ datesWithData, ...rest }) => {
  const { settingsStore } = useStores();
  const lang = useObserver(() => settingsStore.language);

  const dataDateSet = React.useMemo(() => {
    const set = new Set<string>();
    if (datesWithData) {
      for (const d of datesWithData) {
        set.add(`${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`);
      }
    }
    return set;
  }, [datesWithData]);

  return (
    <ReactDatePicker
      locale={lang}
      renderDayContents={(dayOfMonth, date) => {
        const hasData = date
          ? dataDateSet.has(`${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`)
          : false;
        return (
          <div className="day-container">
            {dayOfMonth}
            {hasData && <span className="day-data-dot" />}
          </div>
        );
      }}
      calendarStartDay={1}
      inline
      {...rest}
    />
  );
};

export default DatePicker;
